import React, { useState } from "react";
import AsynchronousAutocomplete from "./Autocomplete/AsynchronousAutocomplete";

function TablePickerFromSalesarea(props) {
  const [salesarea, setSalesarea] = useState(null);

  return (
    <>
      <AsynchronousAutocomplete
        async={{
          url: "core/vestigingen/search?fields=id as value, systeemNaam as label&per_page=30",
          searchField: "systeemNaam",
        }}
        disableClearable={true}
        onChange={(e, option) => {
          setSalesarea({ id: option.value });
        }}
      />
      <AsynchronousAutocomplete
        async={{
          url: "core/tafels/search?fields=id as value, naam as label",
          searchField: "naam",
          perPage: 50,
          extraFilters: [
            {
              field: "vestiging_id",
              operator: "=",
              value: salesarea?.id,
            },
          ],
        }}
        defaultValue={props.defaultValue?.map((item) => ({ value: item.id, label: item.naam })) ?? []}
        disabled={!salesarea?.id}
        key={salesarea?.id ?? 0}
        multiple={true}
        onChange={(e, options) => {
          props.handleValue(options.map((option) => ({ id: option.value, naam: option.label })));
        }}
      />
    </>
  );
}

export default TablePickerFromSalesarea;
